import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

// 路由
export const routes = [
  {
    name: "home",
    path: "/",
    redirect: "/tourist/index",
    component: () => import("@/views/tourist/index"),
    meta: {
      title: "游客中心",
    },
  },
  {
    name: "tourist",
    path: "/tourist",
    redirect: "/tourist/index",
    component: () => import("@/views/layout/tourist"),
    children: [
      {
        name: "touristIndex",
        path: "index",
        component: () => import("@/views/tourist/index"),
        meta: {
          title: "我的订单",
        },
      },
      {
        name: "touristCoupon",
        path: "coupon",
        component: () => import("@/views/tourist/coupon"),
        meta: {
          title: "我的优惠券",
        },
      },
      {
        name: "touristInfo",
        path: "info",
        component: () => import("@/views/tourist/info"),
        meta: {
          title: "个人中心",
        },
      },
    ],
  },
  {
    name: "order",
    path: "/order",
    redirect: "/tourist/index",
    component: () => import("@/views/layout/order"),
    children: [
      {
        name: "orderAdd",
        path: ":model/:buy_type/:mid/:goods_id/:prop_id",
        component: () => import("@/views/order/add"),
        meta: {
          title: "预定",
        },
      },
      {
        name: "orderPay",
        path: "pay/:id",
        component: () => import("@/views/order/pay"),
        meta: {
          title: "支付",
        },
      },
      {
        name: "orderSuccess",
        path: "success/:id",
        component: () => import("@/views/order/success"),
        meta: {
          title: "支付成功",
        },
      },
    ],
  },
  {
    name: "auth",
    path: "/auth",
    redirect: "/auth/login",
    component: () => import("@/views/layout/auth"),
    children: [
      {
        name: "AuthLogin",
        path: "login",
        component: () => import("@/views/auth/login"),
        meta: {
          title: "登录",
          keepAlive: true, //开启缓存
        },
      },
      {
        name: "AuthRegister",
        path: "register",
        component: () => import("@/views/auth/register"),
        meta: {
          title: "注册",
          keepAlive: true, //开启缓存
        },
      },
      {
        name: "AuthForget",
        path: "forget",
        component: () => import("@/views/auth/forget"),
        meta: {
          title: "忘记密码",
          keepAlive: true, //开启缓存
        },
      },
    ],
  },
  {
    path: "*",
    redirect: "/",
  }, //默认跳转
];

// 将路由表装载到router
export default new Router({
  // require service support
  // mode: "history",
  scrollBehavior: () => ({
    y: 0,
  }),
  routes: routes,
});
